import { cn } from '@savvy-kit/lib/utils';
import { isNil } from 'es-toolkit';

import type { DateCellContentProps } from '../../types/cell-types';

export function DateCellContent({ value, description, className }: DateCellContentProps) {
  const displayValue = value instanceof Date ? value.toLocaleDateString() : String(value);

  return (
    <div className={cn('flex flex-col gap-0.5', className)}>
      <span className="text-sm text-dark">{displayValue}</span>
      {!isNil(description) && <span className="text-xs text-secondary">{description}</span>}
    </div>
  );
}
